import React, { useEffect } from "react";

const Appointment = () => {
  useEffect(() => {
    window.location.href =
      "https://sparrow-beige-y9na.squarespace.com/appointments";
  }, []);

  return null;
};

export default Appointment;
